import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import './SchemeFAQ.css';
import AskFaq from "../../../Images/askFaq.png";
function SchemeFAQ() {
  return (
    <>
      <section className="faq-block">
        <Container className="table-boxFaqScheme">
          <Row>
            <Col md={8}>
              <h3>Frequently Asked Questions</h3>
      
              <span className="textRed">No Data found</span>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default SchemeFAQ;
